export const AUTH_TOKEN = 'AUTH_TOKEN'
export const JWT_TOKEN = 'JWT_TOKEN'
